/* app/App.jsx — композиция провайдеров + роутер. Точка входа React-дерева.
   Порядок провайдеров важен: Toast/Confirm должны быть выше тех, кто их зовёт. */

import { AuthProvider } from './providers/AuthProvider.jsx';
import { BreakpointProvider } from './providers/BreakpointProvider.jsx';
import { ConfirmProvider } from './providers/ConfirmProvider.jsx';
import { NewBuildNotice } from './providers/NewBuildNotice.jsx';
import { ToastProvider } from './providers/ToastProvider.jsx';
import { UnsavedProvider } from './providers/UnsavedChangesProvider.jsx';
import { WorkspaceTabSync } from './providers/WorkspaceTabSync.jsx';
import { AppRoutes } from './routes.jsx';
import { NotificationsProvider } from '../hooks/useNotificationsStore.jsx';
import { RR } from '../lib/router.jsx';

  const { BrowserRouter } = RR;

  function App() {
    return (
      <BrowserRouter>
        <BreakpointProvider>
          <AuthProvider>
            <ToastProvider>
              <ConfirmProvider>
                <UnsavedProvider>
                  {/* пространство, выбранное в соседней вкладке, — через сторож несохранённого */}
                  <WorkspaceTabSync />
                  {/* новая сборка на сервере — тост «Обновить» в открытой вкладке */}
                  <NewBuildNotice />
                  <NotificationsProvider>
                    <AppRoutes />
                  </NotificationsProvider>
                </UnsavedProvider>
              </ConfirmProvider>
            </ToastProvider>
          </AuthProvider>
        </BreakpointProvider>
      </BrowserRouter>
    );
  }

export { App };
